import { type FC, type ReactNode } from 'react'
import { type EventTypeHost } from '../../../../../models/Scheduling'
import { getRoleGroupForRoles } from '../../../../ManageTeam/InviteRoleGroups'

interface HostStatusProps {
  host: EventTypeHost
}

export const HostStatus: FC<HostStatusProps> = ({ host }) => {
  if (host.status !== 'active') {
    return <span className='badge rounded-2 zocks-bg-color-gray-200 zocks-text-gray-600 text-nowrap text-capitalize'>{host.status ?? 'inactive'}</span>
  }
  return host.eligible ? null : (
    <span className='badge rounded-2 zocks-bg-color-warning-background zocks-text-gray-900 text-nowrap'>Calendar not connected</span>
  )
}

interface HostIdentityProps {
  host: EventTypeHost
  displayName?: string
}

export const HostIdentity: FC<HostIdentityProps> = ({ host, displayName }) => {
  const roleName = getRoleGroupForRoles(host.roleIds ?? [])?.name
  return (
    <span className='d-flex flex-column'>
      <span className='fw-bold'>{displayName ?? host.name ?? host.email ?? host.userId}</span>
      <span className='d-flex align-items-center paragraph-small'>
        {roleName ? <span className='zocks-text-gray-700'>{roleName}</span> : null}
        {roleName && host.email ? <i className='bi bi-dot zocks-text-gray-500' aria-hidden='true' /> : null}
        {host.email ? <span className='zocks-text-gray-700'>{host.email}</span> : null}
      </span>
    </span>
  )
}

interface HostRowProps {
  host: EventTypeHost
  action?: ReactNode
}

export const HostRow: FC<HostRowProps> = ({ host, action }) => (
  <div className='d-flex align-items-center justify-content-between gap-3 p-3 border-bottom zocks-border-color-gray-200'>
    <HostIdentity host={host} />
    <div className='d-flex align-items-center gap-3'>
      <HostStatus host={host} />
      {action}
    </div>
  </div>
)
